import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MatchedDuplicate, SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import { PaginatedApiResponse } from '@wdx/clmi/api-services/models';
import { Observable } from 'rxjs';
import { PaginationOptions } from '../../models/pagination-options';
import { ApiPaginationService } from '@wdx/shared/infrastructure/api-service';
import { ConfigService } from '../../services/config.service';
import { EntityTypeDuplicatesResolverService } from '@wdx/clmi/clmi-swagger-gen/api-services';

@Injectable()
export class DuplicatesService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);
    private apiPaginationService = inject(ApiPaginationService);
    private entityTypeDuplicatesResolverService = inject(
        EntityTypeDuplicatesResolverService,
    );

    getDuplicates(
        entity: SystemEntity,
        paginationOptions: PaginationOptions,
    ): Observable<PaginatedApiResponse<MatchedDuplicate>> {
        const service =
            this.entityTypeDuplicatesResolverService.getService(entity);
        if (service) {
            return service.get({}, paginationOptions);
        }
        return this.http.get<PaginatedApiResponse<MatchedDuplicate>>(
            `${this.config.getConfiguration().API_BASE}/${entity}/duplicates`,
            {
                headers:
                    this.apiPaginationService.mapPaginationOptions(
                        paginationOptions,
                    ),
            },
        );
    }

    runDuplicateCheck(entity: SystemEntity): Observable<MatchedDuplicate> {
        return this.http.put<MatchedDuplicate>(
            `${this.config.getConfiguration().API_BASE}/${entity}/duplicates`,
            {},
        );
    }

    markNotDuplicates(duplicateId: string): Observable<MatchedDuplicate> {
        return this.http.post<MatchedDuplicate>(
            `${
                this.config.getConfiguration().API_BASE
            }/duplicate/${duplicateId}/notduplicate`,
            {},
        );
    }

    mergeDuplicates(
        duplicateId: string,
        targetId: string,
    ): Observable<MatchedDuplicate> {
        return this.http.post<MatchedDuplicate>(
            `${
                this.config.getConfiguration().API_BASE
            }/duplicate/${duplicateId}/merge/${targetId}`,
            {},
        );
    }
}
